module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAADFBMVEUAAAA0NDQ0NDQzMzPCChFqAAAAA3RSTlMA40mAJZ3FAAAAL0lEQVQoz2MYJIAzAYnDfgGJw/9hQDmc/8EgAeIwCOcCOgehbJC4Gh6IiOAdHAAAdnsw1YeYYHQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add.png
// module id = Dgxh
// module chunks = 2